import { Navigate } from 'react-router-dom'
import { DashboardRouteImport } from './Import'
const { RoutesMap, Dashboard, StudentDashboard, isStudent } = DashboardRouteImport

// Students always land on their own dashboard, everyone else on the regular one
const MainDashboard = () => isStudent() ? <Navigate to={RoutesMap.STUDENT_DASHBOARD.path} replace /> : <Dashboard />
const StudentHome = () => isStudent() ? <StudentDashboard /> : <Navigate to={RoutesMap.DASHBOARD.path} replace />

const DashboardRoute = () => {
    return [
        {
            path: RoutesMap.DASHBOARD.path,
            element: <MainDashboard />
        },
        {
            path: RoutesMap.DASHBOARDSECOND.path,
            element: <MainDashboard />
        },
        {
            path: RoutesMap.STUDENT_DASHBOARD.path,
            element: <StudentHome />
        }
    ]
}

export default DashboardRoute;
